import { Language } from '@frontend/mui'
import { IntlLocales } from '@frontend/t7nd'

function readLangPackages() {
  const jsonContext = (require as any).context('./lang', false, /\.json$/)

  // 动态导入所有 JSON 文件并生成一个对象，key 是文件名，value 是文件内容
  const jsonData = jsonContext
    .keys()
    .reduce((acc: Record<string, string>, filePath: string) => {
      const fileName = filePath.replace('./', '').replace('.json', '') // 去掉路径和扩展名
      const fileContent = jsonContext(filePath) // 获取文件内容
      acc[fileName] = fileContent
      return acc
    }, {})
  return jsonData
}

export const useLocaleMessage = (locale: IntlLocales) => {
  const messages = readLangPackages()[locale]
  return { locale, messages }
}
export const LocaleDict: Record<Language, IntlLocales> = {
  EN_GB: 'en_GB',
  ZH_HANS_CN: 'zh_Hans_CN',
  ZH_HANT_HK: 'zh_Hant_HK',
}
